import React, { useEffect, useState } from "react";
import reactCSS from "reactcss";
import { SketchPicker } from "react-color";
import _uniqueId from "lodash/uniqueId";
import { Button } from "react-bootstrap";
import ModalComponent from "../ModalComponent";

import Drop from "../../Assets/Images/drop.png"

const ColorPicker = ({ onChange, startColor, className = ``, label = `` }) => {
  const [displayColorPicker, setDisplayColorPicker] = useState(false);
  const [color, setColor] = useState(startColor || "transparent");

  useEffect(() => {
    if (startColor && startColor !== color) {
      setColor(startColor);
    }
  }, [startColor]);

  const id = _uniqueId("field_");
  const handleClick = () => {
    setDisplayColorPicker(!displayColorPicker);
  };

  const handleClose = () => {
    setDisplayColorPicker(false);
  };

  const handleChange = (color) => {
    setColor(color.hex);
    if (typeof onChange === "function") {
      onChange(color.hex);
    }
  };

  const handleRemove = () => {
    setColor("transparent");
    if (typeof onChange === "function") {
      onChange('transparent');
    }
  };

  const styles = reactCSS({
    default: {
      color: {
        width: "56px",
        height: "56px",
        borderRadius: "18px",
        background: `${color}`,

      },
      swatch: {
        cursor: "pointer",
      },
      popover: {
        position: "sticky",
        zIndex: "2",
      },
      cover: {
        position: "fixed",
        top: "0px",
        right: "0px",
        bottom: "0px",
        left: "0px",
      },
      drop: {
        backgroundImage: `url(${Drop})`,
        backgroundSize: "26px",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        height: 56
      }
    },
  });

  const picker = displayColorPicker ? (
    <div style={styles.popover} id={id}>
      <div style={styles.cover} onClick={handleClose} />
      <SketchPicker color={color} onChange={handleChange} />
    </div>
  ) : null;

  return (
    <div className={`${className} cs-color-picker`}>
      <label className="label" htmlFor={id}>
        {label}
      </label>
      <div className="color-container">
        <div style={styles.color} onClick={handleClick}>
          <div style={styles.drop} />
        </div>
      </div>
      <div className="">
        {color && color !== "transparent" ? (
          <Button
            type="button"
            className="btn-sm cs-clean-btn"
            onClick={handleRemove}
          >
            Clean
          </Button>
        ) : null}
      </div>
      <ModalComponent
        data={picker}
        modalIsOpen={displayColorPicker}
        setModalIsOpen={setDisplayColorPicker}
        showCloseIcon={false}
        showCloseText={false}
      />
    </div>
  );
};

export default ColorPicker;
